import { render, staticRenderFns } from "./QuestionnaireInfoEdit.vue?vue&type=template&id=9bf6cfac&"
import script from "./QuestionnaireInfoEdit.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireInfoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports